/*
 * Confidential and Proprietary.
 * Do not distribute without 1-800-Flowers.com, Inc. consent.
 * Copyright 1-800-Flowers.com, Inc. 2019. All rights reserved.
 */
import {
    take, fork, call, select, put, takeLatest,
} from 'redux-saga/effects';
import mbpLogger from 'mbp-logger';
import {
    recordPaymentMethodType,
    recordPaymentMethodTypeCompleted,
} from './Payment-Actions';

import {
    disablePaymentFields,
    getOrderId,
    getPaymentMethod,
} from '../../../Checkout/ducks/Common/Common-Selectors';
import { checkJWT } from '../../../Checkout/ducks/Global/Global-Operations';
import {
    getAppliedPromotions, getIfGiftCardApplied, getOrderStatus,
    getTotalRewardAmount,
} from '../Cart/Cart-Selectors';
import {
    calcualteShippingPaymentMethodIsChanged,
    calcualteShippingPaymentMethodIsChangedCompleted,
} from './CalculateCart/CalculateCart-Actions';
import cartServiceClient from '../../../../../apis/cart-service-apis/cartServiceClient';
import { cartStatusCompleteList } from '../../../../../app/helpers/common/helper';
import { prepareRetreiveCart } from '../Cart/ducks/RetrieveCart/PrepareRetreiveCart-Operations';
import { retrieveCart } from '../Cart/ducks/RetrieveCart/RetrieveCart-Operations';
import { updateShowLoadingMessage } from '../../../Common/ducks/ShowLoadingMessage/ShowLoadingMessage-Actions';

function* workerRecordPaymentMethodType() {
    try {
        const isGiftCardApplied = yield select(getIfGiftCardApplied);
        const cartPromotions = yield select(getAppliedPromotions);

        if (isGiftCardApplied || cartPromotions?.length > 0) {
            yield put(updateShowLoadingMessage());
        }
        const currentPaymentMethod = yield select(getPaymentMethod);
        const isGiftCardCoverFullOrderTotal = yield select(disablePaymentFields);
        const cartId = yield select(getOrderId);
        const orderStatus = yield select(getOrderStatus);

        if (cartId) {
            if (!cartStatusCompleteList.includes(orderStatus)) {
                const jwtToken = yield call(checkJWT);
                let paymentMethodType = currentPaymentMethod.id || 'CreditCard';
                const totalRewardAmount = yield select(getTotalRewardAmount);

                if (isGiftCardCoverFullOrderTotal) {
                    paymentMethodType = 'GiftCard';
                }
                const payload = {
                    env: {},
                    jwtToken,
                    cartId,
                    paymentMethod: paymentMethodType,
                };

                const recordResult = yield call(cartServiceClient.initPayment, payload);

                if (recordResult.data.result === 'SUCCESS') {
                    yield put(calcualteShippingPaymentMethodIsChanged());

                    // if the payment method is changed, we need to recalculate the cart
                    if (isGiftCardApplied || cartPromotions?.length > 0 || Number(totalRewardAmount) > 0) {
                        yield call(prepareRetreiveCart);
                        yield call(retrieveCart);
                    }

                    yield take(calcualteShippingPaymentMethodIsChangedCompleted().type);
                }
            }
        }
    } catch (ex) {
        console.error('recordPaymentMethodTypeWorker - Failed', ex.response?.data);
        console.error('response - Failed', ex.response);
        mbpLogger.logError({
            function: 'recordPaymentMethodTypeWorker',
            appName: process.env.npm_package_name,
            module: 'Payment-Operations.js',
            message: 'Failed - recordPaymentMethodType',
            jsError: ex,
        });
    }

    yield put(recordPaymentMethodTypeCompleted());
}

function* watchRecordPaymentMethodType() {
    yield takeLatest(recordPaymentMethodType().type, workerRecordPaymentMethodType);
}

const watchers = [
    fork(watchRecordPaymentMethodType),
];

export {
    watchers,
};

export default {};
